/* eslint-disable import/no-named-as-default */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getLanguage } from "service/axios.service";
import en from "./locales/en";
import pt from "./locales/pt";

const resources = {
  en,
  pt,
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: getLanguage(),
    debug: false,

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
